$(document).ready(function() {
    "use strict";
    $('[data-toggle="popover"]').popover();

    var sidenav            = $(".sidenav"),
        sidenavToggle      = $(".sidenav-toggle"),
        navBarToggle       = $('.navbar-top .navbar-toggle'),
        menuBars      = $(".menu-bars"),
        navbarOverlay      = $('.nav-overlay'),
        contentWrap        = $(".content-wrap"),
        navContent         = $('#nav-content'),
        contentWrapEffect  = contentWrap.data("effect"),
        windowHeight       = $(window).height() - 61,
        windowWidth        = $(window).width(),
        lastWindowWidth    = windowWidth,
        breakXS            = 1018; //768 + 250 sidebar

    function sidenavShow() {
        sidenav.addClass("show").removeClass("sidenav-hide");
        if ($(window).width() > breakXS) contentWrap.addClass(contentWrapEffect);
    //    sidenavToggle.find("span").removeClass("fa-bars").addClass("fa-times");
        navbarOverlay.stop().fadeIn(300);
        menuBars.addClass("hidden");
        window.setTimeout(function() {
            navContent.trigger('nav:resize');
        },300);
    }

    function sidenavHide() {
        sidenav.removeClass("show").addClass("sidenav-hide");
        contentWrap.removeClass(contentWrapEffect);
        // sidenavToggle.find("span").removeClass("fa-arrow-left").addClass("fa-bars");
        navbarOverlay.stop().fadeOut(300);
        menuBars.removeClass("hidden");
        window.setTimeout(function() {
            navContent.trigger('nav:resize');
        },300);
    }


    /**************************************************
     * Attach Events
     **************************************************/
    /*
        Remember what the user has explicitly done so that we can automatically
        toggle the show/hide of the nav where appropriate (see window resize event)
     */
    var userToggledSideNavClass = 'show';
    sidenavToggle.click( function() {
        if( sidenav.hasClass("show") ) {
            sidenavHide();
            userToggledSideNavClass = 'sidenav-hide';
        } else {
            if (!navBarToggle.hasClass('collapsed') && $(window).width() <= breakXS) navBarToggle.click();
            sidenavShow();
            userToggledSideNavClass = 'show';
        }
    });

    navBarToggle.on('click', function() {
        if ($(this).hasClass('collapsed')) {
            sidenavHide();
            navbarOverlay.stop().fadeIn(300);
        }
        else {
            navbarOverlay.stop().fadeOut(300);
        }
    });

    navbarOverlay.on('click', function() {
        sidenavHide();
        if (!navBarToggle.hasClass('collapsed')) navBarToggle.click();
        $(this).stop().fadeOut();
    });

    $(window).on('resize', function() {
        var newWidth = $(this).width();
        if (lastWindowWidth > breakXS && newWidth <= breakXS) {
            sidenavHide();
            navbarOverlay.stop().hide();
        }
        else if (lastWindowWidth <= breakXS && newWidth > breakXS) {
            if (userToggledSideNavClass === 'show') sidenavShow();
            if (!navBarToggle.hasClass('collapsed')) navBarToggle.click();
        }
        lastWindowWidth = newWidth;

        navContent.trigger('nav:resize');
    });


    /**************************************************
     * Initialize Style
     **************************************************/
    if (windowWidth <= breakXS) {
        sidenavHide();
    }
    else {
        sidenavShow();
    }

});





// WEBPACK FOOTER //
// ./resources/assets/js/nav.js